import React from 'react';
import styles from '../../../../styles/usageRights.module.css';
import { useUsageRight } from '../UsageRightsProvider';
import UsageRightCard from './UsageRightCard';

function UsageRightCards() {
  const { currentData } = useUsageRight();
  return (
    <div className={styles.usageRightCardContainer}>
      {currentData?.map((request) => (
        <UsageRightCard key={request._id} request={request} />
      ))}
    </div>
  );
}

export default UsageRightCards;
